import defaultTranslations from './vernacularTexts.json';
import defaultTranslationsHindi from './vernacularTexts_hi.json';
import * as actions from './vernacularActions';
import {defaultLanguage, languages} from "./VernacularConfig";

const initialState = {
  disableVernacular: true,
  defaultLanguage,
  languages,
  selectedLanguage: defaultLanguage,
  texts: defaultTranslations,
  showLanguagePicker: false,
  showLoadingTranslations: false,
  refreshLanguage : 0,
  lang: "",
  status: "NOT_DONE", // TODO Vernac
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.ACTION_SET_VERNACULAR_CONFIG: {
      const {data: config} = action;
      const staticTranslation = config.selectedLanguage.code === 'hi' ? defaultTranslationsHindi : defaultTranslations
      const texts = {
        ...staticTranslation,
        ...config.translations
      }
      return {
        ...state,
        disableVernacular: !!config.disableVernacular,
        languages: config.availableLanguages,
        selectedLanguage: config.selectedLanguage,
        texts
      };
    }
    case actions.ACTION_SET_AVAILABLE_LANGUAGES: {
    }
    case actions.ACTION_TOGGLE_SHOW_LANGUAGE_PICKER: {
      return {
        ...state,
        showLanguagePicker: action.data
      };
    }
    case actions.ACTION_SHOW_FETCHING_TRANSLATION_LOADER: {
      return {
        ...state,
        showLoadingTranslations: action.data
      };
    }
    // case actions.ACTION_SET_CURRENT_LANGUAGE: {
    //   const {data: {selectedLanguage, translations}} = action;
    //   const staticTranslation = selectedLanguage.code === 'hi' ? defaultTranslationsHindi : defaultTranslations
    //   const texts = {
    //     ...staticTranslation,
    //     ...translations
    //   }
    //   return {
    //     ...state,
    //     selectedLanguage,
    //     texts,
    //     showLanguagePicker: false
    //   };
    // }
    case actions.ACTION_REFRESH_PAGE_LANGUAGE : {
        return {
          ...state,
          refreshLanguage: ( (state.refreshLanguage + 1) % 2)
        }
    }

    case actions.ACTION_SET_CURRENT_LANGUAGE:
      return {
        ...state,
        lang: action.payload.lang,
      };
    case '@rails/SET_VERNACULAR_STATUS':
      return {
        ...state,
        lang: action.payload.language,
        status: action.payload.status,
      }
    default:
      return state;
  }
};


export default reducer;
